import { FC } from 'react'

import { DateRange } from '../Calendar.types'
import { CalendarRangeBadge } from '../CalendarRangeBadge'
import { HoursCaption } from '../caption/HoursCaption'
import { HoursPicker } from '../HoursPicker'
import { HoursCalendarSkeleton } from './HoursCalendarSkeleton'

type Props = {
  range?: DateRange
  month: Date
  setMonth: (date: Date) => void
  individualSlots?: {
    bordered: { from: string; to: string }[]
    disabled: { from: string; to: string }[]
  }
  resolvedDisabled: {
    before?: Date
    after?: Date
  }
  onMonthClick: () => void
  onHoursDateChange: (date: Date) => void
  setRange: (range?: DateRange) => void
  showSelectedDate: boolean
  onRangeReset: () => void
  isLoading?: boolean
}

export const HoursCalendarPanel: FC<Props> = ({
  range,
  month,
  setMonth,
  individualSlots,
  resolvedDisabled,
  onMonthClick,
  onHoursDateChange,
  setRange,
  showSelectedDate,
  onRangeReset,
  isLoading
}) => {
  if (isLoading) {
    return <HoursCalendarSkeleton />
  }

  return (
    <div className="flex w-[304px] flex-col justify-between p-12 xxs:w-full xxs:p-0">
      <HoursCaption
        currentDate={month}
        month={month}
        setMonth={setMonth}
        onDateChange={onHoursDateChange}
        onTitleClick={onMonthClick}
        pickerMode="hours"
        disabled={resolvedDisabled}
      />
      <div>
        <HoursPicker
          range={range}
          setRange={setRange}
          monthYear={month}
          individualSlots={individualSlots}
        />
        {showSelectedDate && range?.from && range?.to ? (
          <div className="py-8">
            <CalendarRangeBadge
              range={range}
              onRangeReset={onRangeReset}
              format="hours"
            />
          </div>
        ) : (
          <div className="h-[48px]" />
        )}
        {(individualSlots?.bordered.length ?? 0) > 0 && (
          <div className="mt-8 font-bold text-grey-60 text-12">
            <span className="text-bronze-40">—</span> Мои бронирования
          </div>
        )}
      </div>
    </div>
  )
}
